/**
 * Filename validation utility.
 * Rules:
 * - No emojis
 * - No OS-invalid characters
 * - Allows: letters, numbers, space, _ - . ( )
 * - Prevents empty or whitespace-only names
 */

const EMOJI_REGEX = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/u;
const INVALID_CHAR_REGEX = /[<>:"/\\|?*]/;

const hasControlCharacters = (value) => {
  const text = String(value || "");
  for (let i = 0; i < text.length; i += 1) {
    if (text.charCodeAt(i) < 32) return true;
  }
  return false;
};

export const truncate = (filename, max = 15) => {
  if (!filename || filename.length <= max) return filename;

  const lastDotIndex = filename.lastIndexOf(".");

  if (lastDotIndex === -1) {
    return filename.slice(0, max) + "...";
  }

  const name = filename.slice(0, lastDotIndex);
  const ext = filename.slice(lastDotIndex);
  const available = max - ext.length - 1;

  if (available <= 0) {
    return "..." + ext.slice(0, max - 1);
  }

  return name.slice(0, available) + "..." + ext;
};

export const validateFileName = (fileName, maxLength = 200) => {
  if (!fileName || typeof fileName !== "string") {
    return { valid: false, reason: "Filename is required." };
  }

  const trimmed = fileName.trim();

  if (!trimmed) {
    return { valid: false, reason: "Filename cannot be empty." };
  }

  if (trimmed.length > maxLength) {
    return {
      valid: false,
      reason: `Filename too long. Skipped `,
    };
  }

  const parts = trimmed.split(".");
  const nameWithoutExt =
    parts.length > 1 ? parts.slice(0, -1).join(".") : trimmed;

  if (!nameWithoutExt.trim()) {
    return { valid: false, reason: "Filename is invalid." };
  }

  if (hasControlCharacters(trimmed)) {
    return {
      valid: false,
      reason: "Filename contains invalid control characters.",
    };
  }

  return { valid: true };
};

export const sanitizeFileName = (fileName) => {
  return String(fileName || "")
    .replace(EMOJI_REGEX, "")
    .replace(INVALID_CHAR_REGEX, "")
    .replace(/\s+/g, " ")
    .trim();
};
